import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import InputGroup from '@RHEnvironmental/pattern-library/dist/js/components/InputGroup';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import InlineButtonPanel from '@RHEnvironmental/pattern-library/dist/js/components/InlineButtonPanel';
import InputField from '@RHEnvironmental/pattern-library/dist/js/components/InputField';
import AnchorLink from '@RHEnvironmental/pattern-library/dist/js/components/AnchorLink';
import {
    createUpdateEpc,
    getEpcByProperty,
    reset,
} from '../../../actions/epcLookup';
import BodyText from '../../modules/BodyText';

const EpcLookup = ({ onSuccess, onCancel, property }) => {
    const initialForm = {
        initialValues: {
            id: property.epc?.id,
            property_id: property.id,
            current_energy_rating: property.epc?.current_energy_rating,
            potential_energy_rating: property.epc?.potential_energy_rating,
            environment_impact_current:
                property.epc?.environment_impact_current,
            environment_impact_potential:
                property.epc?.environment_impact_potential,
        },
        initialStatus: {
            errors: {},
        },
    };

    const dispatch = useDispatch();
    const { showLookupSpinner, showLookupError } = useSelector(
        (state) => state.pages.epcLookup
    );

    useEffect(
        () => () => {
            dispatch(reset());
        },
        []
    );

    return (
        <>
            {property?.address ? (
                <Formik
                    onSubmit={(formValues, formHelpers) => {
                        dispatch(
                            createUpdateEpc(formValues, formHelpers, onSuccess)
                        );
                    }}
                    enableReinitialize
                    initialValues={initialForm.initialValues}
                    initialErrors={initialForm.initialStatus}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        setFieldValue,
                        dirty,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form>
                            <Button
                                className="mt-4 mb-4"
                                disabled={showLookupSpinner}
                                onClick={() =>
                                    dispatch(
                                        getEpcByProperty(
                                            property,
                                            setFieldValue
                                        )
                                    )
                                }
                            >
                                EPC Lookup
                            </Button>
                            {showLookupError && (
                                <BodyText>
                                    Could not automatically populate the EPC for
                                    this address.
                                </BodyText>
                            )}
                            <InputContainer>
                                <InputGroup layout="inline">
                                    <InputField
                                        id="current_energy_rating"
                                        onChange={handleChange}
                                        value={values.current_energy_rating}
                                        required
                                        name="current_energy_rating"
                                        errors={
                                            errors &&
                                            errors.current_energy_rating
                                        }
                                        type="text"
                                    >
                                        Current energy rating
                                    </InputField>
                                </InputGroup>
                                <InputGroup layout="inline">
                                    <InputField
                                        id="potential_energy_rating"
                                        onChange={handleChange}
                                        value={values.potential_energy_rating}
                                        required
                                        name="potential_energy_rating"
                                        errors={
                                            errors &&
                                            errors.potential_energy_rating
                                        }
                                        type="text"
                                    >
                                        Potential energy rating
                                    </InputField>
                                </InputGroup>
                                <InputGroup layout="inline">
                                    <InputField
                                        id="environment_impact_current"
                                        onChange={handleChange}
                                        value={
                                            values.environment_impact_current
                                        }
                                        required
                                        name="environment_impact_current"
                                        errors={
                                            errors &&
                                            errors.environment_impact_current
                                        }
                                        type="text"
                                    >
                                        Current environment impact
                                    </InputField>
                                </InputGroup>
                                <InputGroup layout="inline">
                                    <InputField
                                        id="environment_impact_potential"
                                        onChange={handleChange}
                                        value={
                                            values.environment_impact_potential
                                        }
                                        required
                                        name="environment_impact_potential"
                                        errors={
                                            errors &&
                                            errors.environment_impact_potential
                                        }
                                        type="text"
                                    >
                                        Potential environment impact
                                    </InputField>
                                </InputGroup>
                            </InputContainer>
                            <Button
                                onClick={() => {
                                    setFieldValue('current_energy_rating', '');
                                    setFieldValue(
                                        'potential_energy_rating',
                                        ''
                                    );
                                    setFieldValue(
                                        'environment_impact_current',
                                        ''
                                    );
                                    setFieldValue(
                                        'environment_impact_potential',
                                        ''
                                    );
                                }}
                                isLink
                                isUnderlined
                            >
                                Clear EPC values
                            </Button>
                            <InlineButtonPanel>
                                <Button
                                    className="button--white"
                                    onClick={onCancel}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={isSubmitting || !dirty}
                                    onClick={handleSubmit}
                                >
                                    Save
                                </Button>
                            </InlineButtonPanel>
                        </form>
                    )}
                </Formik>
            ) : (
                <BodyText className="mt-4">
                    The inspection must have an address before the EPC can be
                    added.
                </BodyText>
            )}
        </>
    );
};

export default EpcLookup;
